/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_SubmitInputs */

const en_guest_book_submit = /** @type {(inputs: Guest_Book_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book`)
};

const pl_guest_book_submit = /** @type {(inputs: Guest_Book_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj`)
};

/**
* | output |
* | --- |
* | "Book" |
*
* @param {Guest_Book_SubmitInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_submit = /** @type {((inputs?: Guest_Book_SubmitInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_SubmitInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_submit(inputs)
	return en_guest_book_submit(inputs)
});